<template>
  <layout-default :show-backpack="false" :show-promo-message="false"> 
    <NewHome />
  </layout-default>
</template>

<script>
   
    import LayoutDefault from "@/layouts/Default";
    import NewHome from "@/views/new-version/NewHome";

    export default {
        components: {
           
            LayoutDefault,
            NewHome,
        },
        data(){
            return {
                showModal: false
            }
        },
        mounted(){
            localStorage.clear();
            var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
            (function(){
            var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
            s1.async=true;
            s1.src='https://embed.tawk.to/60c91eb57f4b000ac037ce23/1f88pvtk9';
            s1.charset='UTF-8';
            s1.setAttribute('crossorigin','*');
            s0.parentNode.insertBefore(s1,s0);
            })();


            if(this.$route.query.transactionFailed){
                //open modal
                const errName = this.$route.query.transactionFailed;
                if(errName === 'time_expired'){
                    window.$('#helperSessionClosedModal')[0].click();
                }
            }

        },
        methods: {
            closeModal(){
                this.showModal = false
            }, 
        }
    };

</script>

<style lang="scss" scoped>
    .float-chat-button{
        position: fixed;
        right: 55px;
        bottom: 60px;
        z-index: 1000;
        background: transparent;
        box-shadow: none;
    }
</style>
